import { render, staticRenderFns } from "./ThemeSelector.vue?vue&type=template&id=fde03510&scoped=true"
import script from "./ThemeSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemeSelector.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ThemeSelector.vue?vue&type=style&index=0&id=fde03510&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde03510",
  null
  
)

export default component.exports